import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Competency } from "../models/competency";

@Injectable({
    providedIn: "root"
})
export class CompetencyService {

    private createHeader() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    constructor(private httpClient: HttpClient) { }
    
  getCompetenciesByUserId(userId: string): Observable<Competency[]> {
    return this.httpClient.get<Competency[]>(`${environment.ApiEndpoint}/Competency/GetCompetenciesByUserId?userId=` + userId, this.createHeader())
      .pipe(
        map((data) => { return data; })
      )
  }
  getEditableCompetenciesByUserId(userId: string): Observable<Competency[]> {
        return this.httpClient.get<Competency[]>(`${environment.ApiEndpoint}/Competency/CreateEditCompetenciesByUserId?userId=` + userId, this.createHeader())
            .pipe(
                map((data) => { return data; })
            )
    }

    deleteCompetency(competency: Competency) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: competency
        };
        return this.httpClient.request('DELETE', `${environment.ApiEndpoint}/Competency/DeleteCompetency`, httpOptions);
    }

  deleteCompetencyByUserId(competency: Competency): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: competency
    };
    console.warn(competency)
    return this.httpClient.request('DELETE', `${environment.ApiEndpoint}/Competency/DeleteCompetencyByUserId`, httpOptions);
  }

    submitCompetencies(planId: string, competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.post<Competency[]>(`${environment.ApiEndpoint}/Competency/SubmitCompetency?planId=`+ planId, competencies, this.createHeader());
    }

    submitCompetencyRating(planId: string, competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.post<Competency[]>(`${environment.ApiEndpoint}/Competency/SubmitCompetencyRating?planId=`+ planId, competencies, this.createHeader());
    }

    submitCompetencyPriority(planId: string, competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.post<Competency[]>(`${environment.ApiEndpoint}/Competency/SubmitCompetencyPriority?planId=`+ planId, competencies, this.createHeader());
    }

    submitCompetencyLearning(planId: string, competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.post<Competency[]>(`${environment.ApiEndpoint}/Competency/SubmitCompetencyActivityNote?planId=`+ planId, competencies, this.createHeader());
    }

    updateCompetency(competency: Competency) : Observable<Competency> {
        return this.httpClient.put<Competency>(`${environment.ApiEndpoint}/Competency/UpdateCompetency`, competency, this.createHeader());
    }

    updateCompetencyByUserId(competency: Competency): Observable<Competency> {
        return this.httpClient.put<Competency>(`${environment.ApiEndpoint}/Competency/UpdateCompetencyByUserId`, competency, this.createHeader());
    }

    updateCompetencyNotes(competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.patch<Competency[]>(`${environment.ApiEndpoint}/Competency/UpdateCompetencyNotes`, competencies, this.createHeader());
    }

    updateCompetencyRating(competencies: Competency) : Observable<Competency> {
        return this.httpClient.patch<Competency>(`${environment.ApiEndpoint}/Competency/UpdateCompetencyRating`, competencies, this.createHeader());
    }

    updateCompetencyPriority(competencies: Competency[]) : Observable<Competency[]> {
        return this.httpClient.patch<Competency[]>(`${environment.ApiEndpoint}/Competency/UpdateCompetencyPriority`, competencies, this.createHeader());
    }

    createCompetencyByPlanId(competency: Competency, planId: string) : Observable<Competency> {
        return this.httpClient.post<Competency>(`${environment.ApiEndpoint}/Competency/CreateCompetency?planId=`+ planId, competency, this.createHeader());
    }

    scrubCompetency(competency: Competency) : Competency{
        const clone = JSON.parse(JSON.stringify(competency));
        clone.ReflectionNotes = clone.ReflectionNotes?.replace(/./g, x => x);
        clone.Name = clone.Name?.replace(/./g, x => x);
        clone.ActivityNote = clone.ActivityNote?.replace(/./g, x => x);
        return clone;
    }

    scrubCompetencies(competencies: Competency[]) : Competency[] {
        const clone = JSON.parse(JSON.stringify(competencies));
        clone.forEach((r : Competency) => {
            r.ReflectionNotes = r.ReflectionNotes?.replace(/./g, x => x);
            r.Name = r.Name?.replace(/./g, x => x);
            r.ActivityNote = r.ActivityNote?.replace(/./g, x => x);
        });
        return clone;
    }
}
